<div>
	<div class="p-like">
		<span class="text-primary text-bold" :title="title">{{title}}</span>
	</div>
	<div class="p-like details">
		<span>
			<strong>{{ $t('vm.root.shop.invoice-item.subscription-date') }}</strong>
			{{ formattedDate }}
		</span>
	</div>
	<div class="p-like childs-space-between">
			<a
				v-if="isPaid"
				:href="invoice.invoice_url"
				target="_blank"
				rel="noopener noreferrer"
				class="btn btn-primary"
				:title="$t('vm.root.shop.invoice-item.invoice-download-title')"
			>
				{{ $t('vm.root.shop.invoice-item.invoice-download-text') }}
			</a>
			<strong v-else-if="isInProgress" class="text-warning">{{ $t('vm.root.shop.invoice-item.in-progress') }}</strong>
			<strong v-else class="text-danger">{{ $t('vm.root.shop.invoice-item.unpaid') }}</strong>
			<span v-if="hasDispute" class="text-danger marg-t-1 full-line">
				<i18n :path="'vm.root.shop.invoice-item.dispute-title'" tag="span">
					<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
						<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
					</svg>
				</i18n>
			</span>
	</div>

</div>
